import { IGiangVienBan } from "../../model/respone/category/IGiangVienBan";
import { apiClient } from "../apiClient";

export const GIANG_VIEN_BAN_API = "giang-vien-ban";
export const giangVienBanApi = {
  SelectAll: () => apiClient.get(`${GIANG_VIEN_BAN_API}`),
  Insert: (payload: IGiangVienBan) => apiClient.post(`${GIANG_VIEN_BAN_API}`, payload),
  Update: (payload: IGiangVienBan) => apiClient.put(`${GIANG_VIEN_BAN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${GIANG_VIEN_BAN_API}/${id}`),
};
